<template lang="pug">
  .topic-card.relative.column
    .placeholder.image
    .info
      .placeholder.title.m-top-auto
      .placeholder.subtitle.m-top-1
</template>

<script>

export default {

}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.topic-card{
  background-color: $white;
  box-shadow: 0 2px 8px 0 $shadow-gray;
  width: 100%;
  height: 220px;
  margin: 0;
  overflow: hidden;
  border-radius: 8px;
  .info{
    padding: 14px;
  }
}

.placeholder{
  background-color: $light-gray;
  &.image{
    height: 130px;
  }
  &.title{
    height: 20px;
    width: 220px;
  }
  &.subtitle{
    height: 12px;
    width: 150px;
  }
}
</style>
